// API DTO models aligned to Centaur2.Business/Dtos (Phase 1.3 contracts).
// These types mirror the C# server DTOs for use in UserManagementApiService and
// the user-management feature pages.

export interface ContactDto {
  displayName: string;
  email: string;
  roleKey: string;
  entraObjectId: string | null;
}

export interface SupportInfoDto {
  contactEmail: string;
  serviceNowUrl: string;
}

export interface FotDto {
  id: number;
  name: string;
  externalId: string;
  isActive: boolean;
}

export interface UserNotificationPreferenceDto {
  notificationPreferenceTypeId: number;
  key: string;
  displayName: string;
  isEnabled: boolean;
}

export interface UserProfileDto {
  id: number;
  entraObjectId: string;
  displayName: string;
  email: string;
  title: string | null;
  supervisor: string | null;
  status: string;
  lastLoginDate: string | null;
  provisionedDate: string | null;
  roleKey: string;
  allFotsForWork: boolean;
  allFotsForNotifications: boolean;
  fotsForWork: FotDto[];
  fotsForNotifications: FotDto[];
  notificationPreferences: UserNotificationPreferenceDto[];
}

export interface UserListItemDto {
  id: number;
  displayName: string;
  email: string;
  roleKey: string;
  supervisor: string | null;
  status: string;
  lastLoginDate: string | null;
  provisionedDate: string | null;
  allFotsForWork: boolean;
  allFotsForNotifications: boolean;
  fotsForWork: FotDto[];
  fotsForNotifications: FotDto[];
}

export interface UserListParams {
  searchTerm?: string;
  roleKeyFilter?: string;
  pageNumber: number;
  pageSize: number;
}

export interface GraphUserDto {
  entraObjectId: string;
  displayName: string;
  email: string;
  title: string | null;
  supervisor: string | null;
  detectedRoleKeys: string[];
  isAlreadyProvisioned: boolean;
  isDeprovisionedInDb: boolean;
}

export interface ProvisionUserRequest {
  entraObjectId: string;
  allFotsForWork: boolean;
  fotIdsForWork: number[];
  allFotsForNotifications: boolean;
  fotIdsForNotifications: number[];
}

export interface UpdateFotAssignmentRequest {
  allFotsForWork: boolean;
  fotIdsForWork: number[];
  allFotsForNotifications: boolean;
  fotIdsForNotifications: number[];
}

export interface PreferenceSelectionDto {
  notificationPreferenceTypeId: number;
  isEnabled: boolean;
}

export interface UpdatePreferencesRequest {
  preferences: PreferenceSelectionDto[];
}

export interface NotificationPreferenceTypeDto {
  id: number;
  key: string;
  displayName: string;
  isActive: boolean;
  roleKeys: string[];
}

export interface CreateNotificationPreferenceTypeRequest {
  key: string;
  displayName: string;
  roleKeys: string[];
}

export interface UpdateNotificationPreferenceTypeRequest {
  displayName: string;
  isActive: boolean;
  roleKeys: string[];
}
